export const EMPTY_TEST_VALUES = ['', {}, [], null, undefined, Symbol(), function () { }, new Map(), new Set(), NaN];
